export default (name: string) => {
	return `${name} is a required field`;
};
